<template>
  <div class="sidebar">
    <div class="logo">
      <b-img-lazy v-if="GET_IS_DARK_MODE" :src="require('@/assets/images/VOIPLogo-white.svg')" />
      <b-img-lazy v-else :src="require('@/assets/images/VOIP-Phone-Business-Logo.svg')" />
    </div>
    <div class="menu">
      <ul>
        <router-link v-for="(data,index) in sidebar" :key="index" tag="li" class="cursor-pointer" :to="data.to">
          <div>
            <b-icon :icon="data.icon" class="mr-2" />
            <span>{{data.text}}</span>
          </div>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import { GET_IS_DARK_MODE, GET_IS_LOGGED_IN, GET_USER } from '@/store/constants'
import { mapGetters } from 'vuex'
import { routes_names } from '@/router/constants';
export default {
  name: 'Sidebar',
  computed: {
    ...mapGetters([
      GET_USER,
      GET_IS_LOGGED_IN,
      GET_IS_DARK_MODE,
    ]),
    sidebar(){
      return [
        {
          text: 'Dashboard',
          icon: 'house-fill',
          to: {
            name: routes_names.main,
          },
        },
        {
          text: 'Pincodes',
          icon: 'house-fill',
          to: {
            name: routes_names.cp_detect_pincodes
          }
        },
        {
          text: 'Centeral Points',
          icon: 'house-fill',
          to: {
            name: routes_names.cp_detect_centeral_points
          }
        },
        {
          text: 'Document Approvals',
          icon: 'house-fill',
          to: {
            name: routes_names.cp_detect_document_approvals
          }
        },
        {
          text: 'CORS Allowed Domains',
          icon: 'house-fill',
          to: {
            name: routes_names.error_capture_cors_allowed_domains
          }
        },
        {
          text: 'SIP Incoming Call Tests',
          icon: 'house-fill',
          to: {
            name: routes_names.error_capture_sip_incoming_call_tests
          }
        },
        {
          text: 'Errors',
          icon: 'house-fill',
          to: {
            name: routes_names.error_capture_errors
          }
        },
        {
          text: 'Web SIP Logs',
          icon: 'list-ul',
          to: { name: routes_names.error_capture_web_sip_logs }
        },
        {
          text: 'SIP Logs',
          icon: 'house-fill',
          to: {
            name: routes_names.error_capture_sip_logs
          }
        },
        {
          text: 'User Actions',
          icon: 'house-fill',
          to: {
            name: routes_names.error_capture_user_actions
          }
        },
        {
          text: 'Uptime Kuma Services',
          icon: 'house-fill',
          to: {
            name: routes_names.error_capture_uptime_kuma_services
          }
        },
        {
          text: 'Agents',
          icon: 'house-fill',
          to: {
            name: routes_names.error_capture_agents
          }
        },
        {
          text: 'Credentials',
          icon: 'house-fill',
          to: {
            name: routes_names.automation_credentials
          }
        },
        {
          text: 'Automation Servers',
          icon: 'house-fill',
          to: {
            name: routes_names.automation_servers
          }
        },
        {
          text: 'Loud Tests',
          icon: 'house-fill',
          to: {
            name: routes_names.automation_loud_test
          }
        },
        {
          text: 'Servers',
          icon: 'house-fill',
          to: {
            name: routes_names.universal_ai_servers
          }
        },
        {
          text: 'Api Keys',
          icon: 'house-fill',
          to: {
            name: routes_names.universal_ai_api_keys
          }
        },
        {
          text: 'Logs',
          icon: 'house-fill',
          to: {
            name: routes_names.universal_ai_logs
          }
        },
        {
          text: 'Filters',
          icon: 'x-circle-fill',
          to: {
            name: routes_names.call_stats_filters,
          },
        },
        {
          text: 'Thresholds',
          icon: 'x-circle-fill',
          to: {
            name: routes_names.call_stats_thresholds,
          },
        },
        {
          text: 'Sip Servers',
          icon: 'x-circle-fill',
          to: {
            name: routes_names.call_stats_sip_servers,
          },
        },
        {
          text: 'Call Hangup Reports',
          icon: 'x-circle-fill',
          to: {
            name: routes_names.call_stats_call_hangup_reports,
          },
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.dark-theme {
  .sidebar {
    color: $white;
    background-color: $dark-card;
    > .menu {
      > ul {
        > li {
          &:not(.router-link-exact-active):hover {
            background-color: #000000aa;
          }
          &.router-link-exact-active {
            background-color: $black;
          }
        }
      }
    }
  }
}
.sidebar {
  grid-area: sideBar;
  color: $black;
  background-color: $light-card;
  border-radius: 0.5rem;
  padding: 0.5rem;
  overflow: hidden;
  display: grid;
  grid-template-rows: auto 1fr;
  > .logo {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    margin-top: 1rem;
    max-height: 100px;
    > img {
      object-fit: contain;
      height: 100%;
      width: 100%;
      padding: 0.5rem;
    }
  }
  > .menu {
    overflow: auto;
    > ul {
      list-style: none;
      padding: 0px;
      gap: 0.25rem;
      display: flex;
      flex-direction: column;
      > li {
        &:not(.router-link-exact-active):hover {
          background-color: #ffffffaa;
          border-radius: 0.5rem;
        }
        padding: 0.5rem;
        &.router-link-exact-active {
          background-color: $white;
          border-radius: 0.5rem;
        }
      }
    }
  }
}
</style>
